

// Query keys para colaboradores
export const collaboratorsQueryKeys = {
    all: ['collaborators_private'] as const,
    lists: () => [...collaboratorsQueryKeys.all, 'list'] as const,
    list: (filters: string) => [...collaboratorsQueryKeys.lists(), { filters }] as const,
    details: () => [...collaboratorsQueryKeys.all, 'detail'] as const,
    detail: (id: string) => [...collaboratorsQueryKeys.details(), id] as const,
};





